import {StorageWrapper} from './StorageWrapper'
import {AudioManager, AudioType as AudioTypeEnum} from '@colonist/audio'

export const audioManager = AudioManager

/**
 * @deprecated
 * Use `AudioType` from `@colonist/audio` instead
 */
export import AudioType = AudioTypeEnum

/**
 * @deprecated
 * Use `AudioManager` from `@colonist/audio` instead
 */
export module Sound {
    /**
     * @deprecated
     * Use `AudioManager.DEFAULT_VOLUME` from `@colonist/audio` instead
     */
    export const DEFAULT_VOLUME = AudioManager.DEFAULT_VOLUME

    /**
     * @deprecated
     * Use `AudioType` from `@colonist/audio` instead
     */
    export import SoundType = AudioTypeEnum

    /**
     * @deprecated
     * Use `AudioManager.init()` from `@colonist/audio` instead
     */
    export function loadSounds() {
        const volume = StorageWrapper.getMasterVolume()
        void AudioManager.init(volume)
    }

    /**
     * @deprecated
     * Use `AudioManager.setMasterVolume()` from `@colonist/audio` instead
     */
    export function setMasterVolume(newVolume: number) {
        StorageWrapper.setMasterVolume(newVolume)
        AudioManager.setMasterVolume(newVolume)
    }

    /**
     * @deprecated
     * Use `AudioManager.play()` from `@colonist/audio` instead
     */
    export function playSound(sound: SoundType, relativeVolume?: number | undefined, pitch?: number | undefined) {
        AudioManager.play(sound, relativeVolume, pitch)
    }
}
